<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="d-flex justify-content-between">
            <button
              @click="mtdBack"
              type="button"
              class="btn btn-sm text-white"
              style="background: #E46666"
            >
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </div>
        </CCardHeader>
        <CCardBody>
          <div>
            <CButtonGroup>
              <div class="d-flex flex-wrap align-items-center">
                <CButton                  
                  class="m-2"
                  v-for="role in roles"
                  :key="role.role.id"
                  @click="activateRole(role.role.id, role.role.name)"
                  :color="mtdGetClass(role.role.name)"
                >
                  {{ role.role.name }}
                </CButton>
                <div class="mx-2" style="border-left: 2px solid #ccc; height: 32px;"></div>
                <CButton
                  class="m-2"
                  @click="activatePaymentConfig"
                  :color="showPaymentConfig ? 'warning' : 'default'"
                >
                  <i class="fas fa-money-bill-wave"></i> Configuración de pago
                </CButton>
              </div>
            </CButtonGroup>
          </div>
          <div v-if="showPaymentConfig">
            <PaymentConfigVue
              class="pt-3"
              :barberId="selectedBarberId"
              :barberName="selectedBarberName"
              @mtdBack="mtdBack"
            />
          </div>
          <div v-else-if="activeRoleId">
            <PersonalVue
              class="pt-3"
              :roleId="activeRoleId"
              :roleName="activeRoleName"
              @mtdBack="mtdBack"
              @changeTab="changeTab"
              @openPaymentConfig="onOpenPaymentConfig"
            />
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapActions } from "vuex";
import PersonalVue from "../Katalynas/components/crudPersonal.vue";
import PaymentConfigVue from "../Katalynas/components/crudPaymentConfig.vue";

export default {
  name: "c-maintenanca-personal",
  components: { PersonalVue, PaymentConfigVue },

  data() {
    return {
      activeRoleId: null,
      activeRoleName: '',
      showPaymentConfig: false,
      selectedBarberId: null,
      selectedBarberName: '',
      roles: [],
    };
  },
  created() {
    this.get_companyRole();
  },
  watch:{
    
  },
  methods: {
    ...mapActions(["get", "post"]),
    get_companyRole() {
      this.get({
        url: this.$store.getters.get__url + "/companyRole",
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.roles = response.data;
        if (this.roles.length > 0) {
          this.activateRole(this.roles[0].role.id, this.roles[0].role.name);
        }
      });
    },
    activateRole(roleId, roleName) {
      this.activeRoleId = roleId;
      this.activeRoleName = roleName;
      this.showPaymentConfig = false;
    },
    activatePaymentConfig() {
      this.showPaymentConfig = true;
      this.selectedBarberId = null;
      this.selectedBarberName = '';
      this.activeRoleId = null;
      this.activeRoleName = '';
    },
    onOpenPaymentConfig({ barberId, barberName }) {
      this.selectedBarberId   = barberId;
      this.selectedBarberName = barberName;
      this.showPaymentConfig  = true;
      this.activeRoleId       = null;
      this.activeRoleName     = '';
    },
    mtdBack() {
      this.$emit("mtdBack");
    },
    changeTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    mtdGetClass: function(name){
      return name == this.activeRoleName?'info':'default';
    }
  },
};
</script>

<style lang="scss" scoped></style>